
/**
 * One object to export them all.
 * date: YYYY-MM-DD HH:MM
 * mobileNumber: Swedish Mobile Numbers with or without +46
 * SSN: Swedish Social Security Number
 * */
export const pattern = {
  date: /[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1]) (2[0-3]|[01][0-9]):[0-5][0-9]/,
  mobileNumber: /^(([+]46)\s*(7)|07)[02369]\s*(\d{4})\s*(\d{3})$/,
  SSN: /^(19|20)?[0-9]{2}[- ]?((0[0-9])|(10|11|12))[- ]?(([0-2][0-9])|(3[0-1])|(([7-8][0-9])|(6[1-9])|(9[0-1])))[- ]?[0-9]{4}$/
}

export const testDateTimeSupport = () => {
  try {
    var test = document.createElement("input");
    test.type = "datetime-local";
    if (test.type === "text") {
      return false;
    }
  } catch (e) {
    return false;
  }

  return true;
};

export const testTouch = () => "ontouchstart" in document.documentElement;

export const testIsMobileSize = () =>
  window.matchMedia("(max-width: 600px)").matches;

export const testIsIOS = () => navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

export const insertInArray = (arr, index, newItem) => [
  ...arr.slice(0, index),
  newItem,
  ...arr.slice(index)
];

export const isValidDate = d => d instanceof Date && !isNaN(d);

/** 
 * Parse new date from string for cross browser support.
 * Safari always returns local time instead of UTC.
 * Creates date with UTC standard new Date(YYYY, MM, DD, HH, MM),
 * where MM is array value 0-11, not month number.
 */
export const parseStringAsDate = (datestring) =>
  new Date(...(datestring.split(/\D/).map((x, i) => i == 1 ? x - 1 : x)))
